/**
 * Grammatical phrase for a character's blocked status, for gating messages —
 * so they read "You cannot train while in the Dungeon." instead of the broken
 * "...while dungeon." Mirror of server/src/utils/statusPhrase.ts (keep in sync).
 *
 *   `You cannot train while ${statusPhrase(status)}.`  → "...while in the Dungeon."
 *   `Target is ${statusPhrase(status)}.`               → "Target is travelling."
 */
export function statusPhrase(status: string): string {
  switch (status) {
    case 'DUNGEON':
      return 'in the Dungeon';
    case 'INFIRMARY':
      return 'in the Infirmary';
    case 'TRAVELLING':
      return 'travelling';
    case 'OKAY':
    default:
      return 'otherwise occupied';
  }
}
